import { XIcon } from '@phosphor-icons/react'
import { cn } from 'src/helpers/style'

import { TOAST_VARIANT_STYLES, type ToastVariant } from './variants'

export interface IToastContentProps {
  variant: ToastVariant
  title: string
  message: string
  // Injected by react-toastify when ToastContent is rendered as a toast body.
  closeToast?: () => void
}

export const ToastContent = ({
  variant,
  title,
  message,
  closeToast,
}: IToastContentProps): JSX.Element => {
  const styles = TOAST_VARIANT_STYLES[variant]
  const Icon = styles.icon

  return (
    <div
      role="alert"
      className={cn(
        'flex w-full items-start gap-5 rounded-xl border p-4',
        styles.container,
      )}
    >
      <div className="flex flex-1 items-start gap-3">
        <Icon
          size={16}
          weight="regular"
          aria-hidden
          className={cn('mt-px shrink-0', styles.iconColor)}
        />
        <div className="flex flex-col gap-1">
          <p
            className={cn(
              'text-[11px] font-medium uppercase leading-[1.55] tracking-wide',
              styles.titleColor,
            )}
          >
            {title}
          </p>
          <p
            className={cn('text-xs font-medium leading-snug', styles.bodyColor)}
          >
            {message}
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={closeToast}
        aria-label="Close"
        className={cn(
          'flex size-4 shrink-0 items-center justify-center',
          'transition-opacity hover:opacity-70 focus-visible:outline-none focus-visible:opacity-70',
          styles.bodyColor,
        )}
      >
        <XIcon size={10} weight="bold" aria-hidden />
      </button>
    </div>
  )
}
